import { Injectable } from '@angular/core';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { PushNotificationSchema } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastr: ToastrService) { }

  public showPush(pushNotification: PushNotificationSchema, handler: (notification) => void) {
    const platform = Capacitor.getPlatform().toUpperCase();
    const cssPlatform = platform === 'ANDROID' ? 'ngx-toastr-android' : 'ngx-toastr-ios';
    const options = { timeOut: 5000, toastClass: 'ngx-toastr '+cssPlatform , positionClass: 'toast-top-center', disableTimeOut: true, closeButton: true, enableHtml: true };
    const toast: ActiveToast<any> = this.toastr.show(pushNotification.body+'<div class="container-icon-toast"><img class="icon-toast" src="assets/resources/ic-icon-notification.png"></div>', pushNotification.title, options);

    toast.onTap.subscribe(() => {
      handler(pushNotification);
    });
  }
}
